import { useEffect, useState } from "react";
import client, { apiError } from "../../api/client";
import { toast } from "sonner";
import { Plus, Trash2, Check } from "lucide-react";

const inputCls = "h-9 px-3 rounded-md border border-input bg-background text-sm outline-none focus:ring-2 focus:ring-ring/20";

export default function MessagesManager() {
  const [items, setItems] = useState([]);
  const [text, setText] = useState("");

  const load = () => client.get("/admin/login-messages").then((res) => setItems(res.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!text.trim()) return;
    try { await client.post("/admin/login-messages", { text: text.trim() }); setText(""); load(); }
    catch (err) { toast.error(apiError(err)); }
  };
  const save = async (m) => {
    try { await client.put(`/admin/login-messages/${m.id}`, { text: m.text }); toast.success("Uloženo"); }
    catch (err) { toast.error(apiError(err)); }
  };
  const del = async (id) => {
    if (!window.confirm("Smazat hlášku?")) return;
    try { await client.delete(`/admin/login-messages/${id}`); load(); } catch (err) { toast.error(apiError(err)); }
  };

  return (
    <div className="max-w-2xl">
      <h2 className="font-heading text-lg font-medium mb-1">Hlášky na přihlašovací stránce</h2>
      <p className="text-xs text-muted-foreground mb-4">Při každém načtení loginu se zobrazí náhodně vybraná hláška.</p>
      <div className="flex gap-2 mb-4">
        <input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="Nová hláška…" className={inputCls + " flex-1"} data-testid="message-input" />
        <button onClick={add} data-testid="message-add" className="h-9 px-4 rounded-md bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90 flex items-center gap-1"><Plus className="h-4 w-4" /> Přidat</button>
      </div>
      <div className="border border-border rounded-lg divide-y divide-border">
        {items.map((m, i) => (
          <div key={m.id} className="flex items-center gap-2 px-4 py-2" data-testid={`message-row-${m.id}`}>
            <input
              value={m.text}
              onChange={(e) => setItems((s) => s.map((x) => x.id === m.id ? { ...x, text: e.target.value } : x))}
              className="flex-1 h-9 px-2 rounded-md border border-transparent hover:border-border bg-transparent text-sm outline-none focus:border-ring"
            />
            <button onClick={() => save(m)} className="p-1.5 text-emerald-600 hover:bg-secondary rounded" title="Uložit"><Check className="h-4 w-4" /></button>
            <button onClick={() => del(m.id)} className="p-1.5 text-muted-foreground hover:text-destructive hover:bg-destructive/10 rounded"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
        {items.length === 0 && <div className="px-4 py-8 text-center text-sm text-muted-foreground">Žádné hlášky</div>}
      </div>
    </div>
  );
}
